// extracted by mini-css-extract-plugin
export default {"productGallery":"jJ-z","inQuickShop":"kJ-z"};